import React from 'react';
import { AlertTriangle, ShieldAlert } from 'lucide-react';

const BlockedOverlay = ({ n, minRequired = 5 }) => {
  return (
    <div className="flex flex-col items-center justify-center py-20 px-8" data-testid="blocked-overlay">
      <div className="bg-amber-50 border-2 border-amber-200 rounded-2xl p-10 max-w-lg text-center">
        <ShieldAlert className="w-16 h-16 text-amber-500 mx-auto mb-4" />
        <h3 className="text-xl font-bold text-slate-900 mb-2">Governança Estatística</h3>
        <p className="text-slate-600 mb-4">
          A amostra atual possui apenas <span className="font-bold text-amber-600">{n}</span> empresa(s).
          Para garantir a confidencialidade dos dados, o mínimo necessário é de <span className="font-bold">{minRequired}</span> empresas.
        </p>
        <div className="flex items-center gap-2 justify-center text-sm text-amber-700 bg-amber-100 rounded-lg p-3">
          <AlertTriangle className="w-4 h-4" />
          <span>Ajuste os filtros para incluir mais empresas na amostra.</span>
        </div>
      </div>
    </div>
  );
};

export default BlockedOverlay;
